"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfficeTitleLink = exports.GetSocialLinks = exports.GetPhone = exports.GetGoogleMapLink = exports.GetCTADataId = exports.GetAddress = exports.GenerateGoogleMapLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var OfficeTitleLink = props => {
  if ((0, _lodash.isEmpty)(props.officeTitle)) return null;
  return (0, _titleHeadTag.headTagTitleWithAnchor)(props.officeTitle, props.className, props.titleSize, props.officeLink, '_self', props.officeTitle, 'btn btn-inline', props.schema);
};
exports.OfficeTitleLink = OfficeTitleLink;
var GetPhone = phone => {
  if (phone && !(0, _lodash.isEmpty)(phone.value)) {
    return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'inline',
      label: phone.value,
      dataId: 'contact',
      icon: 'icon-call',
      iconDirection: 'left',
      href: "tel:+1".concat(phone.value)
    });
  } else return null;
};
exports.GetPhone = GetPhone;
var GetAddress = location => {
  if (location) {
    if (location.schema) {
      return /*#__PURE__*/_react.default.createElement("div", {
        itemprop: "address",
        itemscope: "",
        itemtype: "http://schema.org/PostalAddress"
      }, /*#__PURE__*/_react.default.createElement("span", {
        itemprop: "streetAddress"
      }, location.addressLine, location.addressLinesExtra), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
        itemprop: "addressLocality"
      }, location.city, ", ", location.state), /*#__PURE__*/_react.default.createElement("span", {
        itemprop: "postalCode"
      }, " ", location.zip));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", null, location.addressLine, location.addressLinesExtra, /*#__PURE__*/_react.default.createElement("br", null), location.city, ", ", location.state, " ", location.zip);
    }
  } else return null;
};
exports.GetAddress = GetAddress;
var GetGoogleMapLink = location => {
  var mapLink = GenerateGoogleMapLink(location, false);
  if (!(0, _lodash.isEmpty)(mapLink)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "link-padding"
    }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'inline',
      target: '_blank',
      label: 'Get Directions',
      dataId: 'map',
      href: mapLink
    }));
  } else return null;
};
exports.GetGoogleMapLink = GetGoogleMapLink;
var GenerateGoogleMapLink = (location, useExtraAddressLine) => {
  if (location) {
    var addressArray = [location.addressLine, useExtraAddressLine ? location.addressLinesExtra : '', location.city, location.state, location.zip];
    var addressQuery = addressArray.filter(Boolean).join(' ').replace(/ /g, '+');
    return "https://maps.google.com/?q=".concat(addressQuery);
  } else return '';
};
exports.GenerateGoogleMapLink = GenerateGoogleMapLink;
var GetSocialLinks = socialLinks => {
  var FormatSocialLink = socialLink => {
    return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      href: socialLink.linkUrl,
      target: '_blank',
      rel: "noopener noreferrer",
      "aria-label": socialLink.appName
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: socialLink.iconName
    })));
  };
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline"
  }, !(0, _lodash.isEmpty)(socialLinks.facebook) && /*#__PURE__*/_react.default.createElement(FormatSocialLink, {
    appName: 'facebook',
    linkUrl: socialLinks.facebook,
    iconName: 'icon-facebook-solid'
  }), !(0, _lodash.isEmpty)(socialLinks.linkedin) && /*#__PURE__*/_react.default.createElement(FormatSocialLink, {
    appName: 'linkedin',
    linkUrl: socialLinks.linkedin,
    iconName: 'icon-linkedin-solid'
  }), !(0, _lodash.isEmpty)(socialLinks.twitter) && /*#__PURE__*/_react.default.createElement(FormatSocialLink, {
    appName: 'twitter',
    linkUrl: socialLinks.twitter,
    iconName: 'icon-twitter-solid'
  }), !(0, _lodash.isEmpty)(socialLinks.instagram) && /*#__PURE__*/_react.default.createElement(FormatSocialLink, {
    appName: 'instagram',
    linkUrl: socialLinks.instagram,
    iconName: 'icon-instagram-solid'
  }), !(0, _lodash.isEmpty)(socialLinks.youtube) && /*#__PURE__*/_react.default.createElement(FormatSocialLink, {
    appName: 'youtube',
    linkUrl: socialLinks.youtube,
    iconName: 'icon-youtube'
  }));
};
exports.GetSocialLinks = GetSocialLinks;
var GetCTADataId = (label, urlSlug) => {
  var dataLabel = (0, _lodash.isEmpty)(urlSlug) ? 'unknown' : urlSlug.substring(urlSlug.lastIndexOf('/') + 1);
  return "".concat(label, "-").concat(dataLabel);
};
exports.GetCTADataId = GetCTADataId;